// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".label[data-v-4bfc29f1]{vertical-align:1px}", "",{"version":3,"sources":["webpack://./resources/assets/js/online_booking/new/components/appointments/ChooseProduct.vue"],"names":[],"mappings":"AACI,wBACI,kBAAR","sourcesContent":["\n    .label {\n        vertical-align: 1px;\n    }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
